import { IconButton, Modal, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import axios from '../../util/Axios';
import { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import InfoIcon from '@mui/icons-material/Info';
import TestDetails from '../../components/TestDetails/TestDetails';
import { useParams } from 'react-router-dom';

export default function TestList(props) {
  const params = useParams();
  const [tests, setTests] = useState([]);

  const [openVideo, setOpenVideo] = useState(false);
  const [openedTestId, setOpenedTestId] = useState(null);

  const [shouldRefresh, setShouldRefresh] = useState(false);

  const [selectedTestId, setSelectedTestId] = useState(null);

  const handleOpenVideo = (testId) => {
    setOpenedTestId(testId);
    setOpenVideo(true);
    setSelectedTestId(testId);
  };

  const handleCloseVideo = () => {
    setOpenVideo(false);
    setOpenedTestId(null);
  };

  useEffect(() => {
    const userId = params.doctorId ? params.doctorId : props.patient.uuid;
    axios('/strokeTests/details?userId=' + userId).then((data) => {
      const arr = data.data;
      arr.sort((t1, t2) => new Date(t2.createdAt) - new Date(t1.createdAt)); //sort by date desc
      setTests(arr);
      setShouldRefresh(false);
    });
  }, [shouldRefresh, props.patient.uuid, params.doctorId]);

  return (
    <>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Box sx={{ margin: 1 }}>
            <Table size="small" aria-label="purchases">
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Details</TableCell>
                  <TableCell>Result</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tests.map((test) => (
                  <TableRow key={test.uuid} sx={test.uuid === selectedTestId ? { backgroundColor: '#e3f2fd' } : {}}>
                    <TableCell component="th" scope="row">
                      {test.uuid}
                    </TableCell>
                    <TableCell>{test.createdAt.split('.')[0].replace('T', ' ')}</TableCell>
                    <TableCell>
                      <IconButton onClick={() => handleOpenVideo(test.uuid)}>
                        <InfoIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell>{JSON.stringify(test.model1Result)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </TableCell>
      </TableRow>

      <Modal open={openVideo} onClose={handleCloseVideo}>
        <TestDetails id={openedTestId} onClose={handleCloseVideo}></TestDetails>
      </Modal>
    </>
  );
}
